'use client';
var classes = {"root":"m-dd36362e","label":"m-c9357328","thumb":"m-c9a9a60a","trackContainer":"m-a8645c2","track":"m-c9ade57f","bar":"m-38aeed47","markWrapper":"m-b7b0423a","mark":"m-dd33bc19","markLabel":"m-68c77a5b"};

export { classes as default };
//# sourceMappingURL=Slider.module.css.mjs.map
